<template>
  <div id="favorite">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="favorite"></footer-app>
      <!-- favorite -->
      <section :class="{'fade-base': true, 'fade': pageFade}">
        <div class="l-list-menu l-favorite">
          <div class="l-list-menu__tab">
            <div class="l-favorite__head">
              <div class="l-favorite__title">お気に入り（{{ total }}）</div>
            </div>
            <!-- swiper_tab -->
            <div class="swiper-container c-tab-menu js-swiper_tab">
              <div class="swiper-wrapper c-tab-menu__wrap">
                <div :class="{ 'swiper-slide': true, 'c-tab-nav__item': true, 'is-active': !initialTab || initialTab == 0 }" v-on:click="getTotal(1)">ショップニュース</div>
                <div :class="{ 'swiper-slide': true, 'c-tab-nav__item': true, 'is-active': initialTab == 1 }" v-on:click="getTotal(2)">イベント</div>
                <div :class="{ 'swiper-slide': true, 'c-tab-nav__item': true, 'is-active': initialTab == 2 }" v-on:click="getTotal(3)">クーポン</div>
              </div>
            </div>
            <!-- js-_body -->
            <div class="swiper-container js-swiper_tab_body l-favorite__body swiper-container-content">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="l-favorite">
                    <ul v-if="newsList.length == 0" class="c-list-menu c-list-deal c-list-deal--xl has-full">
                      <li>
                        <div class="c-list-deal__item" v-show="!loading">お気に入りしているショップニュースはありません</div>
                      </li>
                    </ul>
                    <ul class="c-list-deal c-list-deal--sm">
                      <li v-for="(news, index) in newsList" :key="index" >
                        <div class="c-list-deal__item">
                          <div v-on:click="redirectNewsDetail(news)" class="c-list-deal__img">
                            <img :src="getImgSrc(news.image && news.image[0])" alt="" />
                          </div>
                          <div class="c-list-deal__info">
                            <div v-on:click="redirectNewsDetail(news)" class="c-list-deal__shop">
                              <div class="c-list-deal__shop--img">
                                <img :src="getImgSrc(news.provider.image[0])" alt="" />
                              </div>
                              <div v-if="news.provider" class="c-list-deal__shop--name">{{ news.provider.shopName }}</div>
                            </div>

                            <div class="c-list-deal__info--head">
                              <div v-on:click="redirectNewsDetail(news)" class="c-list-deal__tag-group">
                              <span v-if="!readNewsExists(news.id)" class="unread"></span>
                                <img
                                  v-if="news.discloseAt && isNew(news.discloseAt)"
                                  src="/assets/images/icon/icon-new.svg"
                                  class="c-list-deal__tag-group--new"
                                />
                                <span v-if="news.category" v-html="newsCategoryType(news.category)"></span>
                              </div>
                              <div v-if="favoriteNewsExists(news.id)" class="c-heart is-active" v-on:click="deleteFavorite(news, NEW_COLLECTION_KEY, news.provider)">
                                <svg width="20" height="18" class="c-heart__active"><use xlink:href="#ic-icon-heart-active" /></svg>
                              </div>
                              <div v-else class="c-heart" v-on:click="addFavorite(news, NEW_COLLECTION_KEY, news.provider)">
                                <svg width="20" height="18" class="c-heart__unactive"><use xlink:href="#ic-icon-heart" /></svg>
                              </div>
                            </div>
                            <div v-on:click="redirectNewsDetail(news)" class="c-list-deal__info--time">
                              <span>{{ formatDateTime(news.discloseAt) }}</span>
                            </div>
                            <div v-on:click="redirectNewsDetail(news)" class="c-list-deal__info--content c-list-deal__info--title line-clamp-hack">
                              <div v-html="autolink(news.content)"></div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="swiper-slide">
                  <ul v-if="events.length == 0" class="c-list-menu c-list-deal c-list-deal--xl has-full">
                    <li>
                      <div class="c-list-deal__item" v-show="!loading">お気に入りしているイベントはありません</div>
                    </li>
                  </ul>
                  <ul class="c-list-menu c-list-deal c-list-deal--xl has-full">
                    <li v-for="(event, index) in events" :key="index">
                      <div class="c-list-deal__item">
                        <div v-if="event.image && event.image.length > 0" v-on:click="redirectEventDetail(event)" class="c-list-deal__img js-keep-ratio" data-ratio="0.746">
                          <img v-bind:src="getImgSrc(event.image && event.image[0])" alt="">
                        </div>
                        <div v-else v-on:click="redirectEventDetail(event)" class="c-list-deal__img js-keep-ratio" data-ratio="0.746">
                          <img src="/assets/images/aeontown-noimg.png" alt="">
                        </div>
                        <div class="c-list-deal__info">
                          <div class="c-list-deal__info--head mb-12">
                            <div v-on:click="redirectEventDetail(event)" class="c-tag c-tag--blue c-tag--xl mr-10">イベント</div>
                            <div v-on:click="redirectEventDetail(event)" v-if="event.eventStartAt" class="c-list-deal__info--period">
                              <small>{{ getSelectYear(event.eventStartAt) }}.</small>{{ getSelectMonth(event.eventStartAt) }}.{{ getSelectDate(event.eventStartAt) }}〜<small>{{ getSelectYear(event.eventEndAt) }}.</small>{{ getSelectMonth(event.eventEndAt) }}.{{ getSelectDate(event.eventEndAt) }}
                            </div>
                            <div v-if="favoriteEventExists(event.id)" class="c-heart c-heart--xl is-active" v-on:click="deleteFavorite(event, EVENT_COLLECTION_KEY, event.provider)">
                               <svg width="30" height="27" class="c-heart__active"><use xlink:href="#ic-icon-heart-active" /></svg>
                            </div>
                            <div v-else class="c-heart c-heart--xl"  v-on:click="addFavorite(event, EVENT_COLLECTION_KEY, event.provider)">
                              <svg width="30" height="27" class="c-heart__unactive"><use xlink:href="#ic-icon-heart" /></svg>
                            </div>
                          </div>
                          <div v-on:click="redirectEventDetail(event)" class="c-list-deal__info--time">
                            <img v-if="isNew(event.discloseAt)" src="/assets/images/icon/icon-new.svg" alt="">
                            <span v-if="event.eventStartAt" >{{ formatDateTime(event.eventStartAt) }}</span>
                          </div>
                          <div v-on:click="redirectEventDetail(event)" v-if="event.title" class="c-list-deal__info--content">
                            <div v-html="event.title"></div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="swiper-slide">
                  <div class="c-coupon-have-name mb-8" v-if="coupons.length == 0" v-show="!loading">
                    お気に入りしているクーポンはありません
                  </div>

                  <ul class="c-list-deal">
                    <li v-for="(coupon, index) in coupons" :key="index" >
                      <div class="c-coupon c-coupon-have-name">
                        <div v-if="coupon.provider" class="c-news__shop" v-on:click="getDataModal(coupon)">
                          <div v-if="coupon.provider && coupon.provider.id" class="c-news__shop--img">
                            <img v-lazy="coupon.provider.image && getImgSrc(coupon.provider.image[0])" alt="" />
                          </div>
                          <div v-else class="c-news__shop--img">
                            <img loading="lazy" src="/assets/images/aeontown-logo.png" />
                          </div>
                          <div v-if="coupon.provider && coupon.provider.id" class="c-news__shop--name">{{ coupon.provider.shopName }}</div>
                          <div v-else class="c-news__shop--name">{{coupon.provider.name}}</div>
                        </div>
                        <div v-if="coupon.image" class="c-coupon__top image-fit js-keep-ratio" data-ratio="0.75" v-on:click="getDataModal(coupon)">
                          <div v-if="coupon.label == '3'" class="c-coupon__top__label label__any">何回でも</div>
                                    <div v-else-if="coupon.label == '2'" class="c-coupon__top__label label__more">複数回</div>
                                    <div v-else-if="coupon.label == '1'" class="c-coupon__top__label">一回限り</div>
                                    <div v-else ></div>
                          <img v-lazy="getImgSrc(coupon.image[0])" alt=""/>
                        </div>
                        <div v-else class="c-coupon__top image-fit js-keep-ratio" data-ratio="0.75" v-on:click="getDataModal(coupon)">
                          <div v-if="coupon.label == '3'" class="c-coupon__top__label label__any">何回でも</div>
                                    <div v-else-if="coupon.label == '2'" class="c-coupon__top__label label__more">複数回</div>
                                    <div v-else-if="coupon.label == '1'" class="c-coupon__top__label">一回限り</div>
                                    <div v-else ></div>
                      <img loading="lazy" src="/assets/images/aeontown-noimg.png" alt=""/>
                    </div>
                    <div class="l-list-coupon__column__info">
                      <div class="l-list-coupon__column__info--guidewrap">
                        <div class="l-list-coupon__column__info--guide line-clamp-hack">
                          <div v-html="removehtml(coupon.guide)"></div>
                        </div>
                      </div>

                      <div class="l-list-coupon__column__info--time">
                        <div v-on:click="getDataModal(coupon)" class="c-tag c-tag--violet">利用期限</div>
                        <div v-if="!coupon.unlimited" v-on:click="getDataModal(coupon)" class="date">{{ coupon.availableFrom && formatDateForOrder(coupon.availableFrom) }}〜{{ coupon.availableTo && formatDateForOrder(coupon.availableTo) }}</div>
                        <div v-else v-on:click="getDataModal(coupon)" class="date">無期限</div>


                      </div>
                      
                      <div class="l-list-coupon__column__info--button">
                        <div class="heart">
                        <div v-if="favoriteCouponExists(coupon)" class="c-heart is-active" v-on:click="deleteFavorite(coupon, COUPON_COLLECTION_KEY, coupon.provider)">
                          <svg width="20" height="18" class="c-heart__active"><use xlink:href="#ic-icon-heart-active" /></svg>
                        </div>
                        <div v-else class="c-heart" v-on:click="addFavorite(coupon, COUPON_COLLECTION_KEY, coupon.provider)">
                          <svg width="20" height="18" class="c-heart__unactive"><use xlink:href="#ic-icon-heart" /></svg>
                        </div>
                        </div>

                        <div class="button">
                          <div v-if="coupon.mogiri" v-on:click="getDataModal(coupon)" class="c-btn c-btn--coupon">詳細をみる</div>
                          <div v-else v-on:click="getDataModal(coupon)" class="c-btn c-btn--coupon">このクーポンを<br>利用する</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="coupon.overline" class="over-coupon">
                      <p class="over-coupon__text"><small>終了しました</small></p>
                    </div>
                  </div>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>
        

      </section>
      <div id="coupon-popup" class="l-shop l-shop--detail l-shop-overlay fixed" v-if="showModal" style=" z-index: 201;">
          <div class="l-list-coupon l-list-coupon--detail p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
            <div class="l-main__head--control l-main__head--control--close" @click="closeCouponModal">
              <img src="/assets/images/icon/icon-close-black.svg" alt="" />
            </div>
            <div class="c-coupon">
              <template v-if="showCouponDialog">
                  <div class="c-coupon__top image-fit js-keep-ratio" data-ratio="0.75">
                    <div v-if="couponDetail.label == '3'" class="c-coupon__top__label label__any">何回でも</div>
                    <div v-else-if="couponDetail.label == '2'" class="c-coupon__top__label label__more">複数回</div>
                    <div v-else-if="couponDetail.label == '1'" class="c-coupon__top__label">一回限り</div>
                    <div v-else ></div>
                    <img :src="getImgSrc(couponDetail.image && couponDetail.image[0])" alt="" />
                  </div>
                  <div class="c-coupon__bot">
                    <div class="c-coupon__time">
                      <div class="c-tag c-tag--violet c-tag--xl">利用期限</div>
                      <div 
                        v-if="favoriteCouponExists(couponDetail)" 
                        class="c-heart c-heart--xl is-active" 
                        v-on:click="deleteFavorite(couponDetail, COUPON_COLLECTION_KEY, couponDetail.provider)"
                      >
                     <svg width="30" height="27" class="c-heart__active">
                        <use xlink:href="#ic-icon-heart-active" />
                      </svg>
                    </div>
                    <div v-else class="c-heart c-heart--xl" v-on:click="addFavorite(couponDetail, COUPON_COLLECTION_KEY, couponDetail.provider)">
                      <svg width="30" height="27" class="c-heart__unactive">
                         <use xlink:href="#ic-icon-heart" />
                        </svg>
                    </div>
                    <span v-if="!couponDetail.unlimited" class="mt-8">{{  couponDetail.availableFrom && formatDateForOrder(couponDetail.availableFrom) }}〜{{ couponDetail.availableTo && formatDateForOrder(couponDetail.availableTo) }}</span>
                    <span v-else class="mt-8" style="width: 100%">無期限</span>
                    <div v-if="!couponDetail.mogiri" class="mt-8 font-size-14 color-4">
                      ※利用の際は従業員へお見せ下さい
                    </div>
                  </div>
                  <div class="c-coupon__content">
                    <div class="font-size-14 color-4" v-if="couponDetail.mogiri" >
                      <div v-if="couponDetail.usableTime && (couponDetail.usableTime.from || couponDetail.usableTime.to)">ご使用可能時間：{{couponDetail.usableTime.from}}～{{couponDetail.usableTime.to}}</div>
                    </div>
                    <h1 class="c-coupon__content--not-bold">
                      <div v-html="autolink(couponDetail.guide)"></div>
                    </h1>
                    <div v-html="autolink(couponDetail.notice)"></div>
                    <div v-if="couponDetail.couponCode">
                      <div class="c-btn c-btn--red mt-16 box-center" @click.prevent="applyMobileOrderCoupon(couponDetail.couponCode)">
                        モバイルオーダーで使用する
                      </div>
                    </div>
                  </div>
                  <div v-if="couponDetail.mogiri && !isUserLoggedIn()" class="pl-16 pr-16">
                    <p v-if="!isUserLoggedIn()" class="color-4 m-0"><small>こちらのサービスを利用するには、ログインが必要です。</small></p>
                  </div>
                  <div v-if="couponDetail.mogiri" >
                    <router-link v-if="!isUserLoggedIn()" to="/account/profile" class="c-btn c-btn--red mt-8 box-center">ログインはこちら</router-link>
                    <div v-else class="c-btn mt-16 box-center" 
                    :class="[couponDetail.unlimited || isDateNow(couponDetail.availableFrom,couponDetail.availableTo) ? 'c-btn--red' : 'c-btn--disabled']" @click.prevent="showUseMogiriCoupon()">
                        このクーポンを利用する
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="showContinueDialog">
                <div class="c-coupon__bot" style="height:auto !important;">
                  <h4 class="text-center m-0" v-if="useCoupnData && useCoupnData.length >= couponDetail.usableNumber && useCoupnData.length > 0">このクーポンは使用済です</h4>
                  <h4 class="text-center m-0" v-else>クーポンを使用しますか？</h4>
                  <div class="pt-12 pl-16 pr-16 color-4" v-if="!useCoupnData || useCoupnData.length < couponDetail.usableNumber || useCoupnData.length <= 0"><b>ご使用後はキャンセルできませんのでご注意ください</b></div>
                  <div class="p-16 font-size-14"> 
                    <div v-if="couponDetail.usableTime && (couponDetail.usableTime.from || couponDetail.usableTime.to)">ご使用可能時間：{{couponDetail.usableTime.from}}～{{couponDetail.usableTime.to}}</div>
                    <div>現在ご使用回数：{{useCoupnData ? useCoupnData.length : "0"}}回 &nbsp;<span v-if="useCoupnData && useCoupnData.length < couponDetail.usableNumber && useCoupnData.length > 0"  style="color: #2B2B2B; text-decoration: underline;" @click.prevent="showUsageHistory()" class="color-1">＞使用履歴</span>

                    </div>
                    <div>残りご使用回数：{{userCountRemaining(couponDetail.usableNumber , (useCoupnData ? useCoupnData.length : 0))}}回</div>
                    <div>クーポンID：{{couponDetail.aiCouponCode}}</div>
                  </div>
                  <div v-if="useCoupnData && useCoupnData.length >= couponDetail.usableNumber && useCoupnData.length > 0">
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="showUsageHistory()">
                        使用履歴を見る
                    </div>
                    <div class="c-btn mt-8 c-btn--coupon box-center" @click.prevent="cancelUseCoupon()">
                        閉じる
                    </div>
                    <!--                     
                    <div class="mt-24 p-16 font-size-14">誤って使用済みにしてしまった方は<span style="color: #2B2B2B; text-decoration: underline;" @click.prevent="showCancellationCoupon(couponDetail)" class="color-1">こちら</span>へ</div>
                    -->
                  </div>
                  <div v-else>
                    <div v-if="couponDetail.tenantSelectedType" class="c-modal__content bg-white pt-0">
                    <p class="c-modal__subTitle mt-0">ショップの選択</p>
                    <div class="mb-8">
                        <select class="c-select" name="" id="" v-model="selectCategoryType" @change="changeSelectCategoryType">
                          <template v-if="selectTenantCategoryList.size > 1"><option value="0">すべて</option>
                          </template>
                          <option v-for="[index, name] of [...selectTenantCategoryList]" :key="index"  :value="index">{{name}}</option>
                        </select>
                    </div>
                    <div class=" mb-8">
                      <select class="c-select" name="" id="" v-model="selectTenantId">
                        <option value="">選択してください</option>
                          <option v-for="(name, index) in selectTenantList" :key="index"  :value="index">{{name}}</option>
                      </select>
                    </div>
                    <div v-if="selectTenantErrMsg != ''" class="font-size-14 color-4"><b>{{selectTenantErrMsg}}</b></div>
                    </div>


                    <div class="c-btn c-btn--red box-center" v-bind:class="{ disabled: isUseCouponEnabled }" @click.prevent="applyUsedCoupon()">
                        使用する
                    </div>
                    <div class="p-16 font-size-12 color-4"><b>※従業員が確認してから押してください</b></div>
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="cancelUseCoupon()">
                        使用しない
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="showUsedCouponDialog">
                <div class="c-coupon__bot" style="height:auto !important;">
                  <h4 class="text-center m-0">このクーポンの使用取消を行いますか？</h4>
                  <div class="p-16 font-size-14 color-4">
                    <p>クーポン発行店舗の従業員の方に認証コードを入力いただいてください<br>クーポンID：{{couponDetail.aiCouponCode}}</p>
                    <input class="c-otp c-input-zip" type="text" maxlength="4" v-model="cancelCode" placeholder="４桁の認証コードを入力してください" />
                  </div>
                  <div>
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="applyCancellationCoupon()">
                        使用取消を行う
                    </div>
                    <div class="p-16 font-size-14"><b>※使用取消を行うボタンは認証コードを入力した従業員の方が押して下さい</b></div>
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="cancelCancellationCoupon()">
                        キャンセル
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="showUsageHistoryDialog">
                <div class="c-coupon__bot" style="height:auto !important;">
                  <h4 class="text-center m-0">このクーポンの使用履歴</h4>
                  <div class="p-16 font-size-14"> 
                    <div v-if="couponDetail.usableTime && (couponDetail.usableTime.from || couponDetail.usableTime.to)">ご使用可能時間：{{couponDetail.usableTime.from}}～{{couponDetail.usableTime.to}}</div>
                    <div>現在ご使用回数：{{useCoupnData ? useCoupnData.length : "0"}}回</div>
                     <div>残りご使用回数：{{userCountRemaining(couponDetail.usableNumber , (useCoupnData ? useCoupnData.length : 0))}}回</div>
                    <div>クーポンID：{{couponDetail.aiCouponCode}}</div>
                  </div>
                   <div class="p-16 pt-0 c-usageHistory-coupon">
                    <ol>
                      <li v-for="(data, index) in useCoupnData" :key="index">{{formatDateTimeCoupon(data.useAt) }} {{ data.shopName }}</li>
                    </ol>
                   </div>
                  <div>
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="closeCouponModal()">
                        閉じる
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

      <div id="error-popup" class="l-shop l-shop--detail l-shop-overlay fixed" v-if="errorModal" style=" z-index: 201;">
        <div class="p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
          <div class="c-modal__dialog--center c-modal__content">
            <div>
              <h3 class="c-modal__title ">上限エラー</h3>
              <div class="text-center "><img src="/assets/images/icon/icon-warning.svg" width="90px"></div>
              <p class="color-2"><b>{{errorLimitMessage}}</b></p>
              <div class="c-btn mt-16 box-center" @click.prevent="closeErrorModal()">
                  閉じる
              </div>
            </div>
          </div>
        </div>
      </div>  

      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
        <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
        <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
       </svg>
      </div>
     <!-- modal show required login -->
     <modal_login_required title="この機能をご利用になるには、"></modal_login_required>
     <alert :message="alert_msg" 
      :show="alert_show" 
      :closeModal="closeModal" 
      :confirm_show="confirm_show" 
      :confirm_message="confirm_msg" 
      :confirm_callback="confirm_callback" 
      :confirm_hide_cancel="confirm_hide_cancel"
      :label_cancel="confirm_label_cancel"
      :label_ok="confirm_label_ok"
      ></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import ModalLoginRequired from "../components/ModalLoginRequired.vue";
import Swiper from "swiper";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { DB, USER_FAVORITE_FIELD, EVENT_FAVORITE_FIELD, COUPON_FAVORITE_FIELD, NEW_COLLECTION_KEY, EVENT_COLLECTION_KEY, COUPON_COLLECTION_KEY } from "../config/const.js";
import {
  getUser,
  getFavoriteNewsOfUser,
  getListShopProviders,
  getFavoriteEventOfUser,
  getFavoriteCouponsOfUser,
  getCouponUseHistorys,
  getCouponDetail,
  getLottery
} from "../store/firestore.js";
const $ = window.$;
import dayjs from "dayjs";
import PopAlert from "../components/PopAlert.vue";
import firebase from "../common/firebaseProject";

export default Vue.extend({
  name: "Favorite",
  components: {
    'footer-app': Footer,
    'header-app': Header,
    'menu-app': Menu,
    'modal_login_required': ModalLoginRequired,
    'alert': Alert,
    PopAlert
  },
  mixins: [Tenant],
  data () {
    return {
      user: undefined,
      newsList: [],
      events: [],
      coupons: [],
      total: 0,
      showModal: false,
      USER_FAVORITE_FIELD: USER_FAVORITE_FIELD,
      EVENT_FAVORITE_FIELD: EVENT_FAVORITE_FIELD,
      COUPON_FAVORITE_FIELD: COUPON_FAVORITE_FIELD,
      NEW_COLLECTION_KEY: NEW_COLLECTION_KEY,
      EVENT_COLLECTION_KEY: EVENT_COLLECTION_KEY,
      COUPON_COLLECTION_KEY: COUPON_COLLECTION_KEY,
      swiper_tab_body: null,
      loading: false,
      initialTab: Common.getUrlParam('tab') || 0,
      showCouponDialog:true,
      showContinueDialog: false,
      showUsedCouponDialog: false,
      useCoupnData:null,
      isUseCouponEnabled:false,
      isUseCouponProcessing:false,
      cancelCode:null,
      selectCategoryType:"0",
      selectTenantId:"",
      errorModal:false,
      errorLimitMessage:"このクーポンは使用上限に達したためご使用できません。",
      showUsageHistoryDialog:false,
      /*
      allTenantCategoryList: {
        5: 'グルメ・フード',
        2: 'ファッション',
        4: 'サービス',
        6: 'アミューズメント',
        3: 'グッズ',
        1: 'スーパーマーケット総合スーパー',
      },
      */
     allTenantCategoryList: new Map([
        ['5', 'グルメ・フード'],
        ['2', 'ファッション'],
        ['4', 'サービス'],
        ['6', 'アミューズメント'],
        ['3', 'グッズ'],
        ['1', 'スーパーマーケット総合スーパー'],
      ]),
      selectTenantCategoryList: new Map(),
      allTenantList: {},
      selectTenantList:{},
      selectTenantErrMsg: "",
    }
  },
  async created () {
     this.providersAll = await getListShopProviders(this.$store.state.shopId);
    this.user = await getUser(this.$store.state.userId);
  },
  async mounted () {
    var _this = this;

    function setCurrentSlide(ele, index) {
      $(".js-swiper_tab .swiper-slide").removeClass("is-active");
      ele.addClass("is-active");
    }

    var swiper_tab = new Swiper('.js-swiper_tab', {
      slidesPerView: 3,
      paginationClickable: true,
      freeMode: true,
      initialSlide: this.initialTab,
      loop: false,
      onTab: function (swiper) {
        var n = swiper_tab.clickedIndex;
      }
    });

    $.each(swiper_tab.slides, function (index, val) {
      var ele = $(this);
      ele.on("click", function () {
        setCurrentSlide(ele, index);
        if(index != _this.$route.query.tab){
          _this.$router.push({ query: { tab: index } });
        }
        swiper_tab_body.slideTo(index, 500, false);
      });
    });

    var swiper_tab_body = new Swiper('.js-swiper_tab_body', {
      direction: 'horizontal',
      loop: false,
      initialSlide: this.initialTab,
      autoHeight: true,
      spaceBetween: 16,
      on: {
        slideChangeTransitionEnd: function () {
          if(!swiper_tab_body) return;
          var n = swiper_tab_body?.activeIndex || 0;
          setCurrentSlide($(".js-swiper_tab .swiper-slide").eq(n), n);
          if(n != _this.$route.query.tab){
            _this.$router.push({ query: { tab: n } });
          }
          swiper_tab.slideTo(n, 500, false);
        },
      }
    });
    this.swiper_tab_body = swiper_tab_body;

    $('.c-coupon').on('click', function () {
      $('#coupon-popup').removeClass('d-none');
    });
    $('.l-main__head--control--close').on('click', function () {
      $('#coupon-popup').addClass('d-none');
    });

    await this.getDataNews();
    this.loading = false;
    await this.getDataEvents();
    await this.getDataCoupons();

    this.swiper_tab_body?.updateAutoHeight();

    Common.initDom();
  },
  updated() {
    this.swiper_tab_body?.updateAutoHeight();
  },
  methods: {
    async getDataNews () {
      const result = await getFavoriteNewsOfUser(this.store.userId)
      this.newsList = result.reverse()
      this.total = this.newsList.length
      this.newsList = this.newsList.map(news => {
        // リンク無効
        news.content = Common.disabledContentLink(news.content);
        return news;
      })
    },
    async getDataEvents () {
      const result = await getFavoriteEventOfUser(this.store.userId)
      this.events = result.reverse()
    },
    async getDataCoupons () {
      const result = await getFavoriteCouponsOfUser(this.store.userId)


      const data = [];
      for (const coupon of result) {
         const overline = await this.overLine(coupon.mogiri,coupon.maximumNumber, coupon.totalUseCount,coupon.id,coupon.lotteryId,coupon.lotteryEntryId,coupon.qreResultId)
         coupon.overline = overline;
         data.push(coupon);
      }
      this.coupons = data;
      this.coupons = result.reverse()
      this.coupons = this.coupons.map(coupon => {
        // リンク無効
        coupon.guide = Common.disabledContentLink(coupon.guide);
        

        return coupon;
      })



    },
    getTotal (tab) {
      switch (tab) {
        case 1:
          this.total = this.newsList.length
          break
        case 2:
          this.total = this.events.length
          break
        default:
          this.total = this.coupons.length
          break
      }
    },
    async getDataModal(couponData) {
      const id = couponData.id;
      const lotteryId = couponData.lotteryId;
      const lotteryEntryId = couponData.lotteryEntryId;
      const qreResultId = couponData.qreResultId;
      this.couponDetail = await getCouponDetail(id)
      if (lotteryId) {
        this.couponDetail.lotteryId = lotteryId;
      }
      if (lotteryEntryId) {
        this.couponDetail.lotteryEntryId = lotteryEntryId;
      }
      if (qreResultId) {
        this.couponDetail.qreResultId = qreResultId;
      }

      if (this.couponDetail.link && 0 < this.couponDetail.link.length) {
        Common.messageHandlers('show_browser', { url: this.couponDetail.link });
        return
      }
      
      //もぎりの場合ユーザーデータを取得し使用状況を確認する
      if (this.couponDetail.mogiri) {
        //ユーザー情報取得
        const userId = this.$store.state.userId;
        //クーポン使用歴確認する
        //今見ているクーポンIDが必要
        //使用可能な時間帯かどうか
        //getCouponUseHistorys = async (userId,this.couponDetail.couponId)
        const useHistorys  = await getCouponUseHistorys(userId,this.couponDetail.id,this.couponDetail.lotteryId,this.couponDetail.lotteryEntryId,this.couponDetail.qreResultId);

        this.useCoupnData = useHistorys.map(useData => {
          useData.shopName = "";
          if (useData.tenantId) {
            const provider = this.providersAll.find(item => item.id == useData.tenantId);
            if (provider) {
              useData.shopName = provider.shopName;
            }
          }
          return useData;
        });

        //使用日ごとに並び替え
        this.useCoupnData.sort((a,b) => {
          if (a.useAt > b.useAt) {
            return 1;
          } else {
            return -1;
          }
        })

        //使用可能な時間帯かどうか
        if (this.couponDetail.usableTime) {
          const now = dayjs();
          const stateTime = this.couponDetail.usableTime.from ? this.couponDetail.usableTime.from.split(':'): null;
          const endTime =  this.couponDetail.usableTime.to ? this.couponDetail.usableTime.to.split(':'): null;
          const nowHour = now.hour();
          const nowMinute = now.minute();
        
          if (stateTime && stateTime.length > 0) {
            if(nowHour < Number(stateTime[0]) ) {
              //非活性にする
              this.isUseCouponEnabled = true;
              if (nowHour == Number(stateTime[0]) && nowMinute > Number(stateTime[1])) {
                this.isUseCouponEnabled = false;
              }
            }
          }
          if (endTime &&endTime.length > 0) {
            if(nowHour > Number(endTime[0]) ) {
              //非活性にする
              this.isUseCouponEnabled = true;
              if ((endTime  == Number(endTime[1])) && nowMinute < Number(endTime[1])) {
                this.isUseCouponEnabled = false;
              }
            }
          }       
        }
        if (this.couponDetail.tenantSelectedType) {
            // 店舗別設定
            this.selectCategoryType = "0";
            this.selectTenantId = "";
            this.selectTenantErrMsg = "";
            this.selectTenantCategoryList = new Map();
            this.allTenantList = {};
            this.selectTenantList = {};
            let temp = [];
            for (const tenantSelectedData of this.couponDetail.tenantSelectedDatas) {
              const provider = this.providersAll.find(item => item.id == tenantSelectedData.tenantId);
              if (provider) {
                temp.push(provider.shopCategoryType);
              }
            }
            // ソート
            /*
            const keys = Object.keys(temp);
            //keys.sort();
            for (let key of keys) {
              this.selectTenantCategoryList[key] = temp[key];
            }*/
            for (let [key, value] of this.allTenantCategoryList) {
              if (temp.includes(key)) {
                this.selectTenantCategoryList.set(key, this.allTenantCategoryList.get(key));
              }
            }

            if(this.selectTenantCategoryList.size == 1) {
              for (let [key, value] of this.selectTenantCategoryList) {
                this.selectCategoryType = key;
              }
            } 

            this.changeSelectCategoryType();
        }
      }
      this.couponDetail.guide = Common.addExtLink(this.couponDetail.guide);
      this.couponDetail.notice = Common.addExtLink(this.couponDetail.notice);

      // Firebase analytics 
      // { tenantId: "テナントID", couponId: "クーポンID", shopId: "SC ID" }
      Common.analyticsLogEvent('use_coupon', this.couponDetail.tenantId ? {
        tenantId: this.couponDetail.tenantId,
        couponId: id,
        shopId: this.SHOP_ID,
      } : {
        couponId: id,
        shopId: this.SHOP_ID,
      });
      
      this.showModal = true
    },
    closeCouponModal() {
      this.showModal = false
      this.couponDetail = {}
      this.showCouponDialog=true;
      this.showContinueDialog= false;
      this.showUsedCouponDialog= false;
      this.useCoupnData=null;
      this.isUseCouponEnabled=false;
      this.showUsageHistoryDialog=false;
      this.loading= false;
      this.cancelCode=null
    },
    closeMogiriCouponModal() {
      this.showContinueDialog = false
    },
    showUseMogiriCoupon() {
      if (
        !this.couponDetail.unlimited &&
        !this.isDateNow(this.couponDetail.availableFrom,this.couponDetail.availableTo)
      ) return false

      this.showCouponDialog = false;
      this.showContinueDialog = true;
    },
    
    cancelUseCoupon() {
      this.closeCouponModal()
    },
    
    showCancellationCoupon() {
      this.showContinueDialog = false;
      this.showUsedCouponDialog = true;
    },

    cancelCancellationCoupon() {
      this.showUsedCouponDialog = false;
      this.showContinueDialog = true;
    },
    //使用済みにする
    async applyUsedCoupon() {
      if (this.isUseCouponEnabled) return false;
      if (this.isUseCouponProcessing) return false;

      if (this.couponDetail.tenantSelectedType) {
        if (!this.selectTenantId) {
          this.selectTenantErrMsg = "選択されていません。"
          return false;
        }
      }
      this.isUseCouponProcessing = true;
      const userId = this.$store.state.userId;
      this.loading = true;
      const callable = firebase.functions('asia-northeast1').httpsCallable('useCoupon');
      const request = {
        "userId": userId,
        "couponId": this.couponDetail.id
      };
      if (this.user && this.user.lineFootPrint) {
        request.lineFootPrint = this.user.lineFootPrint;
      }
      if (this.couponDetail.lotteryId) {
        request.lotteryId = this.couponDetail.lotteryId;
        const lottery = await getLottery(this.couponDetail.lotteryId);
        if (lottery.codeType == 2) {
          // codeType=2（複数コード指定）、かつ同一抽選コードによる抽選を利用不可の場合
          request.lotteryEntryId = this.couponDetail.lotteryEntryId;
        }
      }
      if (this.couponDetail.qreResultId) {
        request.qreResultId = this.couponDetail.qreResultId;
      }
      if (this.couponDetail.tenantSelectedType) {
        request.tenantId = this.selectTenantId;
      }
      const result = await callable(request)
        .catch(async e => {
          this.loading = false;
             this.isUseCouponProcessing = false;
          if (e?.details?.code == "coupon-exceeded-all-limit" || e?.details?.code == "coupon-exceeded-tenant-limit") {

            if (e?.details?.code == "coupon-exceeded-all-limit") {
              this.errorLimitMessage = "全体の上限数に達したため使用できません。"

            } else if (e?.details?.code == "coupon-exceeded-tenant-limit") {
              this.errorLimitMessage = "選択された店舗での上限数に達したため使用できません。"
            }

            this.errorModal = true;
          } else {
            await this.alert("エラーが発生しました。" + (e?.message||""), true);
          }
          throw e;
        });
      if (result.data.status == 'SUCCEED') {
        // Firebase analytics 
        // { tenantId: "テナントID", couponId: "クーポンID", shopId: "SC ID" }
        Common.analyticsLogEvent('mogiri_coupon', this.couponDetail.tenantId ? {
          tenantId: this.couponDetail.tenantId,
          couponId: this.couponDetail.id,
          shopId: this.SHOP_ID,
        } : {
          couponId: this.couponDetail.id,
          shopId: this.SHOP_ID,
        });
        this.closeCouponModal();
        await this.alert(`クーポンを使用しました。`);
        //if (!result) {}
      }
      this.isUseCouponProcessing = false;
    },
    //使用取り消しをする
    async applyCancellationCoupon() {
      if (!this.cancelCode) {
        this.alert("認証コードを入力してください");
        return false;
      }
      this.loading =true;
      const userId = this.$store.state.userId;
      const callable = firebase.functions('asia-northeast1').httpsCallable('cancelCoupon');
      const request = {
        "userId":userId,
        "couponId": this.couponDetail.id,
        "cancelCode": this.cancelCode
      };
      const result = await callable(request)
        .catch(async e => {
                this.loading =false;
          await this.alert("エラーが発生しました。" + (e?.message||""), true);
          throw e;
        });
      if (result.data.status == 'SUCCEED') {
        // Firebase analytics 
        // { tenantId: "テナントID", couponId: "クーポンID", shopId: "SC ID" }
        Common.analyticsLogEvent('cancel_coupon', this.couponDetail.tenantId ? {
          tenantId: this.couponDetail.tenantId,
          couponId: this.couponDetail.id,
          shopId: this.SHOP_ID,
        } : {
          couponId: this.couponDetail.id,
          shopId: this.SHOP_ID,
        });
        this.closeCouponModal();
        await this.alert(`クーポンの使用取消を行いました。`);
      }
    },
    closeErrorModal() {
      this.errorModal = false
      //ここで一覧更新する
    },
    showUsageHistory() {
      this.showContinueDialog = false
      this.showUsageHistoryDialog = true
          },
    changeSelectCategoryType() {
      this.selectTenantId = "";
      this.selectTenantErrMsg = "";
      this.selectTenantList = {};
 const _selectTenantList = {}
      for (const tenantSelectedData of this.couponDetail.tenantSelectedDatas) {
        const provider = this.providersAll.find(item => item.id == tenantSelectedData.tenantId);
        if (provider) {
          if (this.selectCategoryType == "0" || provider.shopCategoryType == this.selectCategoryType) {
            _selectTenantList[provider.id] = provider.shopName;
          }
        }
      }
      const sortTenantList = Object.entries(_selectTenantList).sort((a, b) => a[1].localeCompare(b[1],"ja"));  

      for (const sortTenant of sortTenantList) {
        this.selectTenantList[sortTenant[0]] = sortTenant[1] 
      }
    },
    async overLine(mogiri,maximumNumber,totalUseCount,id,lotteryId,lotteryEntryId,qreResultId) {
      if (mogiri) {
      if (maximumNumber) {
        // 上限到達判定
        // 全店対象、かつ上限数設定がある場合
        if (totalUseCount >= maximumNumber) {
          // 上限を超えている場合、既に使用した人以外はアプリでグレーアウト

          let userData  = await getCouponUseHistorys(this.$store.state.userId,id,lotteryId,lotteryEntryId,qreResultId);

          if (userData.length <= 0) {
            return true;
          }
        }
      }
      }
      return false;
    },
    isDateNow(availableFrom, availableTo) {
      if (!availableFrom)  return true
      const isDateNow = new Date().valueOf();

      //開始日過ぎてる
      if (availableFrom < isDateNow) {
        if (!availableTo)  return true
        if (isDateNow < availableTo) return true
      }
      return false
    },
    userCountRemaining(usablenumber,  useCount) {
      const total = usablenumber - useCount;
      return total > 0 ?  total : 0
    }
  }
})
</script>
